import { createSelector } from '@ngrx/store';
import { TPlani8State } from '../reducers';
import { TOrderListState } from './order-list.models';

export const getOrderListState = (state: TPlani8State) => state.orderListInfo;

export const getOrderListInfo = createSelector(getOrderListState, (state: TOrderListState) => state.orderListInfo);

export const getUserPaginationOption = createSelector(
  getOrderListState,
  (state: TOrderListState) => state.userPaginationOption,
);

export const getOrderUploadDetailsInfo = createSelector(
  getOrderListState,
  (state: TOrderListState) => state.orderUploadDetailsInfo,
);

export const getFactoryOrderSplitInfo = createSelector(
  getOrderListState,
  (state: TOrderListState) => state.orderToFactoriesAllocationInfo,
);

export const getOrderListSelectedFilters = createSelector(
  getOrderListState,
  (state: TOrderListState) => state.orderListSelectedFilters,
);

export const getOrderListBucketInfo = createSelector(
  getOrderListState,
  (state: TOrderListState) => state.orderListViewType,
);
